import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker.
// Requisito installabilità (Chrome/Edge/Android): servire via HTTPS e avere
// un SW registrato con un fetch handler. In preview il frontend gira col dev
// server CRA (NODE_ENV=development), ma siamo comunque in HTTPS: il bug
// cliente era proprio che il SW non si registrava mai perché condizionato a
// production. Ora registriamo sempre quando siamo in HTTPS (o localhost per
// sviluppo locale). Il flag REACT_APP_DISABLE_SW permette di disattivarlo
// esplicitamente se necessario.
const isHttps = typeof window !== "undefined" && window.location.protocol === "https:";
const isLocalhost = typeof window !== "undefined" && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);
const swDisabled = process.env.REACT_APP_DISABLE_SW === "true";

if ("serviceWorker" in navigator && !swDisabled && (isHttps || isLocalhost)) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Listen for updates
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("pwa-update-available"));
            }
          });
        });
      })
      .catch(() => {});
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "SW_UPDATE_AVAILABLE") {
        window.dispatchEvent(new CustomEvent("pwa-update-available"));
      }
    });
  });
}

